import { SystemText } from '@salesperformanceint/e4shared';
import React from 'react';
import { Link } from 'react-router-dom';

const TaskAppraisalSection = props => {
    const { task } = props;

    return (
        <div className="col-md-12">
            <h4>
                <div className="flex">
                    <i className="fa fa-warning text-danger mr10" />
                    <span className="flex-grow">
                        {SystemText('User/Tasks/Review/Complete')}
                        <br />
                        <Link
                            className="mt5"
                            to={`/develop/reviews/${task.appraisal_Id}?oid=${task.date_Completed ? '' : task.id}`}
                        >
                            {SystemText('User/Tasks/Review/Button')}
                        </Link>
                    </span>
                </div>
            </h4>
        </div>
    );
};

export default TaskAppraisalSection;
